import {
  ThirdPlatConfig,
  CoperateStatusMap,
  AuditStatus,
  CollectConfig,
  STEPS,
  CertificateType,
  MerchantType,
  MerchantTypeOptions,
  AuditStatusText,
  MANAGE_TYPE,
} from './type';

export const thirdPlatMap = [
  { value: ThirdPlatConfig.none, label: '无' },
  { value: ThirdPlatConfig.candao, label: '餐道' },
  { value: ThirdPlatConfig.canxingjian, label: '餐行健' },
  { value: ThirdPlatConfig.keruyun, label: '客如云' },
  { value: ThirdPlatConfig.hualala, label: '哗啦啦' },
  { value: ThirdPlatConfig.tiancaishanglong, label: '天财商龙' },
];

export const collectConfigMap = [
  { value: CollectConfig.none, label: '无' },
  { value: CollectConfig.zhengyuanshouyin, label: '正源收银' },
];

export const CooperateStatusoptions = [
  { value: '', label: '全部' },
  { value: CoperateStatusMap.wait, label: '待合作' },
  { value: CoperateStatusMap.process, label: '合作中' },
  { value: CoperateStatusMap.expire, label: '合作过期' },
];

export const MerchantShopStatusoptions = [
  { value: '', label: '全部' },
  { value: 0, label: '启用' },
  { value: 1, label: '停用' },
];

export const AuditModelRemarkOption = [
  { value: 1, label: '盖章完备' },
  { value: 2, label: '仅商户盖章' },
  { value: 3, label: '仅丰食盖章' },
  { value: 4, label: '无合同' },
];
export enum ContractRemarkEnum {
  /** 双方盖章完备 */
  SFGZWB = 5,
  /** 新签商户无合同 */
  NQSHWHT = 6,
  /** 续签商户无合同 */
  XQSHWHT = 7,
}
export const ContractRemarkLabel: Record<ContractRemarkEnum, string> = {
  [ContractRemarkEnum.SFGZWB]: '双方盖章完备',
  [ContractRemarkEnum.NQSHWHT]: '新签商户无合同',
  [ContractRemarkEnum.XQSHWHT]: '续签商户无合同',
};
export const ContractRemarkOption = [
  { value: '', label: '全部' },
  { value: ContractRemarkEnum.SFGZWB, label: ContractRemarkLabel[ContractRemarkEnum.SFGZWB] },
  { value: ContractRemarkEnum.NQSHWHT, label: ContractRemarkLabel[ContractRemarkEnum.NQSHWHT] },
  { value: ContractRemarkEnum.XQSHWHT, label: ContractRemarkLabel[ContractRemarkEnum.XQSHWHT] },
];

export const AuditStatusOptions = [
  { value: AuditStatus.all, label: '全部' },
  { value: AuditStatus.wait_pre_submit, label: AuditStatusText[AuditStatus.wait_pre_submit] },
  { value: AuditStatus.wait_re_submit, label: AuditStatusText[AuditStatus.wait_re_submit] },
  { value: AuditStatus.wait_re_audit, label: AuditStatusText[AuditStatus.wait_re_audit] },
  { value: AuditStatus.re_audit_reject, label: AuditStatusText[AuditStatus.re_audit_reject] },
  { value: AuditStatus.re_audit_pass, label: AuditStatusText[AuditStatus.re_audit_pass] },
  { value: AuditStatus.re_business_pass, label: AuditStatusText[AuditStatus.re_business_pass] },
  { value: AuditStatus.re_business_reject, label: AuditStatusText[AuditStatus.re_business_reject] },
];

export const PAGE_SIZE = 20;

export const allSteps = [
  { value: STEPS.base, title: '注册商户' },
  { value: STEPS.merchant, title: '资料补齐' },
  { value: STEPS.check, title: '合同上传' },
  { value: STEPS.final, title: '合同审核' },
];

export const CertifiTypeOptions = [
  { value: CertificateType.food_busi, label: '食品经营许可证' },
  { value: CertificateType.food_permi, label: '食品生产许可证' },
  { value: CertificateType.three_permi, label: '三小类许可证' },
];

export const cateringModeOptions = [
  { value: 1, label: '中央厨房' },
  { value: 2, label: '社会餐厅' },
  { value: 3, label: '食堂项目' },
  { value: 4, label: '代采项目' },
  { value: 5, label: '测试商户' },
  { value: 6, label: '供应链' },
  { value: 7, label: '美食广场' },
  { value: 8, label: '零食柜' },
  { value: 9, label: '企业直签' },
];

export const canteenTypeOptions = [
  { value: 1, label: '分润食堂' },
  { value: 2, label: '自营食堂' },
  { value: 3, label: '外包食堂' },
];
export const merchantTypeOptions = [
  { value: '', label: '全部' },
  {
    value: MerchantType.shangcheng,
    label: MerchantTypeOptions[MerchantType.shangcheng],
  },
  { value: MerchantType.canyin, label: MerchantTypeOptions[MerchantType.canyin] },
];
export const merchantTypeSAASOptions = [
  { value: '', label: '全部' },
  { value: MerchantType.canyin, label: MerchantTypeOptions[MerchantType.canyin] },
];
export const orderTypeOptions = [{ value: 1, label: '差价模式' }];

export const merchantScaleOptions = [
  { value: 1, label: '单门店' },
  { value: 0, label: '多门店' },
];

export const shopWithdrawStatusOptions = [
  { label: '全部', value: '' },
  { label: '提现锁定', value: 1 },
  { label: '正常', value: 0 },
];
export const merchantMarginFlagOptions = [
  { label: '否', value: 0 },
  { label: '是', value: 1 },
];
export const saasMmerchantMarginFlagOptions = [{ label: '否', value: 0 }];
export const subjectTypeOptions = [
  { label: '上海丰赞科技有限公司', value: 0 },
  { label: '深圳丰赞科技有限公司', value: 1 },
];
export const SettlementPriorityType = [
  {
    label: '优先抽取固定(剩余部分比例抽佣)',
    value: 0,
  },
  {
    label: '优先抽取比例',
    value: 1,
  },
];

//  经营类型
export const mangeTypeOP = [
  { label: '全部', value: '', key: '', content: '全部' },
  { value: MANAGE_TYPE.FOOD, label: '餐饮', key: MANAGE_TYPE.FOOD, content: '餐饮' },
  { value: MANAGE_TYPE.SHOP, label: '商超', key: MANAGE_TYPE.SHOP, content: '商超' },
];

export const mangeTypeMap = {
  [MANAGE_TYPE.FOOD]: '餐饮',
  [MANAGE_TYPE.SHOP]: '商超',
};
